import { IdeogramCjkIcon } from './IdeogramCjkIcon';

/**
 * author: Haley Halcyon
 * id 86B5194A-AB94-4C20-8110-FA463B705B39
 * name ideogram-cjk
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ideogram-cjk.svg
 * tags
 * - Alpha / Numeric 
 */
export const IdeogramChineseJapaneseKoreanIcon = IdeogramCjkIcon;
export default IdeogramChineseJapaneseKoreanIcon